import mitt from 'mitt';
import { Functions } from '@didi/mfe-global-utils/lib-module';
/**
 * 解决 iOS webview 中，软件盘弹起页面不回滚到底部的问题
 */
// className
var CLEAR = 'clear';
var MD_ICON = 'md-icon';
var MD_ICON_CLEAR = 'md-icon-clear';
// ua test
var isIOS = function () { return /iphone os/i.test(window.navigator.userAgent.toLowerCase()); };
// emitter
var emitter = (function () {
    var _emitter = null;
    return function () {
        if (!_emitter) {
            _emitter = mitt();
        }
        return _emitter;
    };
})()();
// emitter 事件
function fakeFocusout(_a) {
    var dom = _a.dom;
    dom.dataset.isFocusin = '0';
    var originTop = dom.dataset.originTop || 0;
    var scrollToBottom = function () {
        if (dom.dataset.isFocusin === '0') {
            window.scrollTo({
                top: +originTop,
                behavior: 'smooth',
            });
        }
    };
    Functions.debouce(scrollToBottom, 300)();
}
function fakeFocusin(_a) {
    var dom = _a.dom;
    dom.dataset.isFocusin = '1';
    var originTop = document.documentElement.scrollTop || document.body.scrollTop;
    dom.dataset.originTop = originTop + '';
}
// 为 native 事件做一层代理
function focusinHandler(event) {
    emitter.emit('focusin', {
        event: event,
        dom: this,
    });
}
function focusoutHandler(event) {
    emitter.emit('focusout', {
        event: event,
        dom: this,
    });
}
// 判断一下是否点击 clear 图标，针对 md-input
function clickHandler(event) {
    if (event.target instanceof HTMLElement) {
        var classMap = event.target.classList;
        if (classMap.contains(CLEAR) &&
            classMap.contains(MD_ICON) &&
            classMap.contains(MD_ICON_CLEAR)) {
            emitter.emit('focusin', {
                event: event,
                dom: this,
            });
        }
    }
}
var _vscrollBottom = {
    inserted: function (el) {
        if (!isIOS())
            return;
        el.addEventListener('focusout', focusoutHandler);
        el.addEventListener('focusin', focusinHandler);
        el.addEventListener('click', clickHandler);
        emitter.on('focusin', fakeFocusin);
        emitter.on('focusout', fakeFocusout);
    },
    unbind: function (el) {
        if (!isIOS())
            return;
        el.removeEventListener('focusout', focusoutHandler);
        el.removeEventListener('focusin', focusinHandler);
        el.removeEventListener('click', clickHandler);
        emitter.off('focusin', fakeFocusin);
        emitter.off('focusout', fakeFocusout);
    }
};
var install = function (Vue) {
    Vue.directive('scrollBottom', _vscrollBottom);
};
export default {
    install: install,
    _vscrollBottom: _vscrollBottom,
};
